export default __webpack_public_path__ + "static/media/google.96a392be.png";